import { Badge } from '@/components/ui/badge';

interface ProductBadgeProps {
  stockStatus: 'in_stock' | 'out_of_stock' | 'preorder' | 'low_stock';
  isNew?: boolean;
  isSale?: boolean;
}

export const ProductBadge = ({ stockStatus, isNew, isSale }: ProductBadgeProps) => {
  return (
    <div className="absolute top-3 left-3 flex flex-col gap-2 z-10">
      {isNew && (
        <Badge className="bg-neon-green hover:bg-neon-green/90 text-black font-pixel text-[8px] px-3 py-1 tracking-wider shadow-lg border-2 border-black uppercase animate-glow-pulse">
          NEW
        </Badge>
      )}

      {isSale && (
        <Badge className="bg-neon-pink hover:bg-neon-pink/90 text-white font-pixel text-[8px] px-3 py-1 tracking-wider shadow-lg border-2 border-black uppercase animate-glow-pulse">
          SALE
        </Badge>
      )}

      {stockStatus === 'preorder' && (
        <Badge className="bg-retro-yellow hover:bg-retro-yellow/90 text-black font-pixel text-[8px] px-3 py-1 tracking-wider shadow-lg border-2 border-black uppercase">
          PRE-ORDER
        </Badge>
      )}

      {stockStatus === 'out_of_stock' && (
        <Badge className="bg-gray-800 text-gray-400 font-pixel text-[8px] px-3 py-1 tracking-wider shadow-lg border-2 border-gray-700 uppercase">
          OUT OF STOCK
        </Badge>
      )}

      {stockStatus === 'low_stock' && (
        <Badge className="bg-brand-accent hover:bg-brand-accent/90 text-white font-pixel text-[8px] px-3 py-1 tracking-wider shadow-lg border-2 border-black uppercase animate-pulse">
          LOW STOCK
        </Badge>
      )}
    </div>
  );
};
